import React from 'react';
import moment from 'common/moment';
import TimeStamp from '../TimeStamp';
import style from './style.scss';

type ReportLayoutProps = {
  filter: JSX.Element;
  showTimeStamp?: boolean;
  graph?: JSX.Element | null;
  body?: JSX.Element | null;
  messages?: JSX.Element | null;
};
const ReportLayout: React.FC<ReportLayoutProps> = (props) => (
  <div className={style.report}>
    <div className={style.reportHeader}>
      <div className={style.filterContainer}>{props.filter}</div>
      {props.showTimeStamp && <TimeStamp date={moment()} extraCssClassName={style.timeStamp} />}
    </div>
    {props.messages && <div className={style.message}> {props.messages} </div>}
    {props.graph}
    {props.body && <div className={style.body}>{props.body}</div>}
  </div>
);
ReportLayout.defaultProps = {
  showTimeStamp: false,
  graph: null,
  messages: null,
  body: null,
};

export default ReportLayout;
